import { Fuel, CreditCard, ShieldCheck, Wrench, Zap, Sparkles, FileCheck, Wallet } from 'lucide-react';

/** Top-USPs für Warenkorb + Kasse — kompakte Conversion-Booster. */
export const TOP_USPS = [
  { icon: Fuel, text: 'FuelGood Guthaben: 0,1 Punkte pro Kilometer — sofort bei Bestellung gutgeschrieben. Bei 15.000 km sind das 1.500 Punkte im Jahr' },
  { icon: CreditCard, text: 'FuelGood Guthaben pro Hotelbuchung aus deinem Guthaben einlösen — direkt verrechnet' },
  { icon: ShieldCheck, text: 'Bestpreis-Garantie auf 1,6 Mio Hotels weltweit' },
  { icon: Wrench, text: 'TÜV, Reifen- & Ölwechsel: bis zu 100 % mit Guthaben zahlen — je nach Guthaben-Stand' },
  { icon: Zap, text: 'Virtuelle Card — sofort aktiv, kein Versand, kein Warten' },
];

/** Kurzfassung für Drawer & Sidebar — schneller scanbar, höhere Conversion. */
export const TOP_USPS_SHORT = [
  { icon: Fuel, text: 'FuelGood Guthaben: 0,1 Punkte pro km — sofort gutgeschrieben' },
  { icon: CreditCard, text: 'FuelGood Guthaben pro Hotelbuchung aus dem Guthaben einlösen' },
  { icon: Wrench, text: 'TÜV, Reifen- & Ölwechsel: bis zu 100 % mit Guthaben — je nach Guthaben-Stand' },
  { icon: ShieldCheck, text: 'Bestpreis-Garantie auf 1,6 Mio Hotels weltweit' },
  { icon: Zap, text: 'Sofort digital aktiv — kein Warten' },
];

/** Konzept-USPs (Plattform-Mehrwert) — ergänzend zu den Reward-USPs, ohne Dopplung. */
export const CONCEPT_USPS = [
  { icon: Sparkles, text: 'Nie wieder zu viel zahlen — KI prüft Versicherung & Autokredit automatisch' },
  { icon: FileCheck, text: 'Volle Kostenkontrolle — Fahrzeuge, Verträge & Service-Fristen an einem Ort' },
  { icon: Wallet, text: 'Spare bei allen KFZ-Kosten — eine Card für Tanken, Service, Versicherung & Reisen' },
];
